import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LANGUAGE, isSupportedLanguage, resources } from './locales'

export const LOCALE_STORAGE_KEY = 'preferred_locale'

function initialLanguage(): string {
	try {
		const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
		return isSupportedLanguage(stored) ? stored : DEFAULT_LANGUAGE
	} catch {
		return DEFAULT_LANGUAGE
	}
}

void i18next
	.use(initReactI18next)
	.init({
		lng: initialLanguage(),
		fallbackLng: DEFAULT_LANGUAGE,
		ns: ['common'],
		defaultNS: 'common',
		resources,
		interpolation: { escapeValue: false },
	})

export default i18next
